import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Translation } from 'react-i18next';
import {
  fetchMe,
  changeShortUsername,
  clearChangeShortUsername,
} from 'redux/users/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';
import ShareOptions from 'components/elements/buttons/ShareOptions';
import FixedNotification from 'components/common/FixedNotification';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';

import validate from './validate';

import './ChangeShortUsername.css';

const ENTER_KEY = 13;

class ChangeShortUsername extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    changeShortUsername: PropTypes.func.isRequired,
    clearChangeShortUsername: PropTypes.func.isRequired,
    me: PropTypes.object,
    changeShortUsernameSuccess: PropTypes.object,
    changeShortUsernameError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    changeShortUsernameSuccess: null,
    changeShortUsernameError: null,
  };

  state = {
    initialValue: '',
    currentValue: '',
    copyUrl: false,
    invalid: false,
  };

  inputEditFieldRef = createRef();

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.me) {
      this.setState({
        initialValue: this.props.me.short_username,
        currentValue: this.props.me.short_username,
      });
    }

    if (this.props.location) {
      const isShortUsernameFocused = this.useQuery(this.props.location.search);
      if (isShortUsernameFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.changeShortUsernameSuccess &&
      this.props.changeShortUsernameSuccess
    ) {
      this.props.fetchMe();
      this.props.clearChangeShortUsername();
    }

    if (prevProps.me.short_username !== this.props.me.short_username) {
      this.setState({ currentValue: this.props.me.short_username });
    }

    if (prevProps.location !== this.props.location) {
      const isShortUsernameFocused = this.useQuery(this.props.location.search);
      if (isShortUsernameFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
    this.props.clearChangeShortUsername();
  }

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this._changeValueHandler();
    }
  };

  handleClickOutside = () => {
    this._changeValueHandler();
  };

  _changeValueHandler = () => {
    this.setState({ invalid: validate(this.state.currentValue) }, this.changeShortUrl);
  };

  changeShortUrl = () => {
    const { initialValue, currentValue, invalid } = this.state;

    if (!invalid && currentValue !== initialValue) {
      this.setState({ initialValue: currentValue});
      this.props.changeShortUsername(currentValue);
    }
  };

  errorHandler = () => {
    const { changeShortUsernameError } = this.props;
    let error = null;

    if (changeShortUsernameError) {
      const shortUsernameError = Object.keys(changeShortUsernameError).map(i => changeShortUsernameError[i]);
      error = { id: 'change-short-username-error', text: shortUsernameError.join(', ') }
    }

    if (this.state.invalid) {
      error = { id: 'change-short-username-error', text: this.state.invalid.text };
    }
    return error;
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  // Short Username can be edited on the <strong>PRO</strong> plan. Check it
  // me.subscription.ff_custom_shortlink

  render() {
    const { me, changeShortUsernameSuccess, changeShortUsernameError } = this.props;
    const { currentValue, copyUrl } = this.state;
    const shortSiteUrl = 'heyl.ink/';

    return (
      <Translation>
        {(t) => (
          <div className="change-short-username__component">
            <div className="change-short-username-wrapper">
              <div
                className={`input-wrapper ${currentValue && currentValue.length >= 15 ?
                  'full-width' : ''}`}
              >
                <span className="prefix">{shortSiteUrl}</span>
                <InputField
                  value={currentValue}
                  onChange={(e) => {
                    e.preventDefault();
                    this.setState({ currentValue: e.target.value });
                  }}
                  customRef={this.inputEditFieldRef}
                  error={this.errorHandler()}
                  validate={validate}
                  disabled={me && me.subscription && !me.subscription.ff_custom_shortlink}
                />
    
                {!changeShortUsernameError && changeShortUsernameSuccess &&
                  <div className="success-icon" />
                }
              </div>
              <div className="subtext">{t("Short Username")}</div>
    
            </div>
    
            <ProFeaturePlaceholder
              className="short-username-pro-placeholder"
              locked={
                me &&
                me.subscription &&
                !me.subscription.ff_custom_shortlink
              }
              placeholderContent={
                <div>
                  {t("Short Username can be edited on the PRO plan.")}
                </div>
              }
            >
              <div className="change-short-username-sharing-options">
                <ShareOptions
                  className="share-change-short-username__component"
                  copyText={me.short_url}
                  copyBtnText={t("Copy Short Link")}
                  onCopy={() => {
                    this.setState({copyUrl: true});
                  }}
                />
              </div>
            </ProFeaturePlaceholder>
    
            {copyUrl === true &&
              <FixedNotification
                onFadeComplete={() => {
                  this.setState({ copyUrl: false });
                }}
              >
                {t("Short link has been copied: paste it anywhere!")}
              </FixedNotification>
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    changeShortUsernameSuccess: state.usersReducer.changeShortUsernameSuccess,
    changeShortUsernameError: state.usersReducer.changeShortUsernameError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    changeShortUsername,
    clearChangeShortUsername,
  },
)(onClickOutside(ChangeShortUsername));
